import { Controller } from "@hotwired/stimulus"

// A settings form's save bar: nothing to save until something changes, and it
// says so — so "Save changes" is never a guess about whether anything is
// pending. Leaving with changes unsaved asks first — a full page unload
// through beforeunload, a Turbo visit (the sidebar's links) through confirm.
export default class extends Controller {
  static targets = ["submit", "status"]

  connect() {
    this.dirty = false
    this.report()
    this.beforeUnload = (event) => {
      if (!this.dirty) return
      event.preventDefault()
      event.returnValue = ""
    }
    this.beforeVisit = (event) => {
      if (this.dirty && !window.confirm("You have unsaved changes. Leave without saving them?")) event.preventDefault()
    }
    window.addEventListener("beforeunload", this.beforeUnload)
    document.addEventListener("turbo:before-visit", this.beforeVisit)
    this.element.addEventListener("submit", () => { this.dirty = false })
  }

  disconnect() {
    window.removeEventListener("beforeunload", this.beforeUnload)
    document.removeEventListener("turbo:before-visit", this.beforeVisit)
  }

  changed() {
    this.dirty = true
    this.report()
  }

  report() {
    this.submitTargets.forEach((submit) => { submit.disabled = !this.dirty })
    if (this.hasStatusTarget) this.statusTarget.textContent = this.dirty ? this.statusTarget.dataset.dirty : this.statusTarget.dataset.clean
  }
}
